// Shared backdrop-theme resolution. The "fable" background swaps its image — and its
// ambience — by local device time, so both the renderer (BoardScene) and the audio engine
// (audio.ts) resolve the day/night variant through this single helper to stay in sync.

import { devFlag } from '@/game/dev';

export type FableVariant = 'fable_day' | 'fable_night';

/**
 * Day (06:00–20:59) → 'fable_day', otherwise 'fable_night'.
 * Dev/staging only: `?fableday` / `?fablenight` URL flags force a variant so both the day and the
 * night look + sound can be checked regardless of the local clock (see src/game/dev.ts).
 */
export function fableVariant(): FableVariant {
  if (devFlag('fableday')) return 'fable_day';
  if (devFlag('fablenight')) return 'fable_night';
  const hour = new Date().getHours();
  return hour >= 6 && hour < 21 ? 'fable_day' : 'fable_night';
}
